
import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { MdOutlineBlock, MdSearch, MdMode, MdDelete, MdRemoveRedEye, MdDownload, MdClose } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Sort from '../../assets/image/sort-down-alt.svg';
import Filter from '../../assets/image/filter.svg';
import Dummy from '../../assets/image/user-circle.svg';
import Pagination from '../../Components/Pagination/Pagination';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import fileCSV from '../../assets/File/Coach_Target.csv'

const CoachTragetManagementView = () => {
    
    const navigate = useNavigate();
    const location = useLocation(); // Access the location object
    const [totalPages, setTotalPages] = useState( 0);
    const [total, setTotal] = useState( 0);
    const [page, setPage] = useState( 1);
    const [perPage, setPerPage] = useState( 10);
    const [search, setSearch] = useState( "");
    const [indexNumber, setIndexNumber] = useState( 0);
    const [id, setId] = useState(0);
    const [user, setUser] = useState([]);
    const [delet, setDelet] = useState(false);
    const deleteClose = (e) => { e.preventDefault(); setDelet(false); }
    const [block, setBlock] = useState(false);
    const blockClose = () => setBlock(false);
    const [addSubAdmin, setAddSubAdmin] = useState(false);
    const subAdminClose = () => setAddSubAdmin(false);
    const subAdminShow = () => setAddSubAdmin(true);
    const [activeTab, setActiveTab] = useState('Primary');
    const [switchtab, setSwitchTab] = useState(false);
    const [ViewStatus, setViewStatus] = useState()
    const [status, setStatus] = useState()
    const [loading, setLoading] = useState(true)

    // Preserve the state when opening modals
    const [modalState, setModalState] = useState(null); // Store location state or any other data you need

    // Use location.state if available, otherwise fallback to default
    const locationState = location.state || {};

    useEffect((e) => {
        // Store the location state in local state to preserve it
        if (location.state) {

            setModalState(location.state); // Save it in a local state
        }
    }, [location.state, delet]);

    const deleteShow = async (e, id) => {
        e.preventDefault()
        setId(id);
        setDelet(true);
    };


    const goBack = () => {
        navigate("/coach-target-management"); // Navigates back to the previous page
    };

    const getUserList = async () => {
        const response = await handleApiCall("get", `${endpoint.coachWiselistOfCoachTarget}?coach_id=${location?.state?.id}&page=${page}&limit=${perPage}`, {});
        try {
            console.log(response, "CoachtargetView============>>>>>")
            if (response?.data?.code === 200) {
                setLoading(false)
                setUser(response?.data?.data?.coachTargetList);
                setTotalPages(response?.data?.data?.total_pages);
                setTotal(response?.data?.data?.total);
            }
            if (response?.response?.data?.success === false) {
                toast.error(response?.response?.data?.errorMessage);
                setTimeout(() => { navigate("/") }, 2000);
            }
        } catch (e) {
            console.log("Error fetching data:", e);
        }
    };
  

    const paginationHandler = (e, i) => {
        e.preventDefault();
        if (i !== page) {
            setPage(i);
            const newIndexNumber = perPage * (i - 1);
            setIndexNumber(newIndexNumber);
        }
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            event.target.value = ""; // 👈 Reset the input value
        }
    };

   

 
   
    const [regionList, setRegionList] = useState([]);
    const [regionIds, setRegionIds] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [countryIds, setCountryIds] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [stateIds, setStateIds] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [districtIds, setDistrictIds] = useState([]);
    const [blockList, setBlockList] = useState([]);
    const [blockIds, setBlockIds] = useState([]);

    // Prevent dropdown from closing on selection
    const [openDropdown, setOpenDropdown] = useState(null);

    // useEffect(() => { getRegionList(); }, []);
    useEffect(() => { if (regionIds.length) getCountryList(); else setCountryList([]); }, [regionIds]);
    useEffect(() => { if (countryIds.length) getStateList(); else setStateList([]); }, [countryIds]);
    useEffect(() => { if (stateIds.length) getDistrictList(); else setDistrictList([]); }, [stateIds]);
    useEffect(() => { if (districtIds.length) getBlockList(); else setBlockList([]); }, [districtIds]);

    const toggleSelection = (id, setState, currentState) => {
        setState(
            currentState.includes(id)
                ? currentState.filter(item => item !== id) // Remove if already selected
                : [...currentState, id] // Add if not selected
        );
    };

    const getRegionList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterRegion}`, {});
            if (response?.data?.code === 200) setRegionList(response.data.data);
            else toast.error(response?.response?.data?.message);
        } catch (e) { console.log("Error fetching region list:", e); }
    };

    const getCountryList = async () => {
        try {
            console.log("regionIds before sending:", regionIds);
            console.log("Type of regionIds:", typeof regionIds);
            // Convert regionIds array to a proper JSON array string
            const queryParam = JSON.stringify(regionIds);

            const response = await handleApiCall("get", `${endpoint.filterCountry}?region_id=${queryParam}`);
            if (response?.data?.code === 200) {
                setCountryList(response.data.data);
            }
        } catch (e) {
            console.log("Error fetching country list:", e);
        }
    };
    const getStateList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterState}?country_id=${JSON.stringify(countryIds)}`, {});
            if (response?.data?.code === 200) setStateList(response.data.data);
        } catch (e) { console.log("Error fetching state list:", e); }
    };

    const getDistrictList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterDistrict}?state_id=${JSON.stringify(stateIds)}`, {});
            if (response?.data?.code === 200) setDistrictList(response.data.data);
        } catch (e) { console.log("Error fetching district list:", e); }
    };

    const getBlockList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterBlock}?district_id=${JSON.stringify(districtIds)}`, {});
            if (response?.data?.code === 200) setBlockList(response.data.data);
        } catch (e) { console.log("Error fetching block list:", e); }
    };

    const [filter_data, setfilter_data] = useState({
        region_id: regionIds,
        country_id: countryIds,
        state_id: stateIds,
        district_id: districtIds,
        block_id: blockIds
    })

    useEffect(() => {
        setfilter_data({
            region_id: regionIds,
            country_id: countryIds,
            state_id: stateIds,
            district_id: districtIds,
            block_id: blockIds
        });
    }, [regionIds, countryIds, stateIds, districtIds, blockIds]);



    const resetFilters = () => {
        setRegionIds([]);
        setCountryIds([]);
        setStateIds([]);
        setDistrictIds([]);
        setBlockIds([]);
    };


   


    const [hasRestoredState, setHasRestoredState] = useState(false);
    const isRestoringState = useRef(true);

    // Restore state when navigating back from view/edit
    useEffect(() => {
        if (location.state?.fromPage) {
            const savedState = JSON.parse(localStorage.getItem("coachTargetManagementState"));
            if (savedState) {
                setTotalPages(savedState.totalPages);
                setTotal(savedState.total);
                setPage(savedState.page);
                setPerPage(savedState.perPage);
                setSearch(savedState.search);
                setIndexNumber(savedState.indexNumber);
                setfilter_data(savedState.filter_data || {});

                // ✅ Restore IDs for filters from saved filter_data
                setRegionIds(savedState.filter_data?.region_id || []);
                setCountryIds(savedState.filter_data?.country_id || []);
                setStateIds(savedState.filter_data?.state_id || []);
                setDistrictIds(savedState.filter_data?.district_id || []);
                setBlockIds(savedState.filter_data?.block_id || []);
            }
            localStorage.removeItem("coachTargetManagementState");
        }

        // ⏳ Delay state trigger until all state has synced
        setTimeout(() => {
            isRestoringState.current = false;
            setHasRestoredState(true);
        }, 0);
    }, [location.state]);
    // ✅ Debounced Search (AFTER restoration)
    console.log(user, "dat...........")
    useEffect(() => {
        if (isRestoringState.current || !hasRestoredState) return;

        const timer = setTimeout(() => {
            setPage(1);
            setIndexNumber(0);
            setTotal(0);
            getUserList();
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    // ✅ Page & PerPage change
    useEffect(() => {
        if (!hasRestoredState || isRestoringState.current) return;
        getUserList();
    }, [page, perPage]);

    // ✅ Filter change — only after restore
    useEffect(() => {
        if (!hasRestoredState || isRestoringState.current) return;
        setPage(1);
        setIndexNumber(0);
        setTotal(0);
        getUserList();
    }, [filter_data]);

    // ✅ Trigger only once after restore (no double API calls)
    useEffect(() => {
        if (hasRestoredState && !isRestoringState.current) {
            getUserList();
        }
    }, [hasRestoredState]);
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-CA"); // Formats as YYYY/MM/DD
    };
    return (
        <>
            <Tab.Container id="left-tabs-example" defaultActiveKey="Profile">
                <div className='row align-items-center'>
                    <div className='my-3  w-full px-2 sm:px-4'>
                        {/* <div className='flex flex-col sm:flex-row justify-between gap-2'>
                            <label className="relative block w-full sm:w-auto">
                                <span className="sr-only">Search</span>
                                <div className="relative w-full">
                                    <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                                        <svg className="h-5 w-5 fill-slate-500" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                        </svg>
                                    </span>
                                    <input
                                        className="placeholder:text-gray-400 block bg-gray-200 rounded-md w-full border border-slate-300 py-2.5 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-base"
                                        placeholder="Search"
                                        type="text"
                                        name="Search"
                                        value={search}
                                        maxLength={150}
                                        onChange={(e) => {
                                            let value = e.target.value;

                                            // Remove leading spaces or special characters
                                            value = value.replace(/^[\s\W_]+/, "");

                                            setSearch(value);
                                        }}
                                    />
                                </div>
                            </label>
                            <div className='flex flex-wrap gap-2 items-center justify-center sm:justify-start'>
                                <button onClick={resetFilters} className="bg-[#F0D7E0] py-2 px-4 mb-2  rounded-md font-bold text-[15px]">All</button>
                                {[
                                    { name: "Region", list: regionList, ids: regionIds, setState: setRegionIds },
                                    { name: "Country", list: countryList, ids: countryIds, setState: setCountryIds },
                                    { name: "State", list: stateList, ids: stateIds, setState: setStateIds },
                                    { name: "District", list: districtList, ids: districtIds, setState: setDistrictIds },
                                    { name: "Block", list: blockList, ids: blockIds, setState: setBlockIds }
                                ].map(({ name, list, ids, setState }) => (
                                    <Dropdown
                                        key={name}
                                        className="mb-2"
                                        show={openDropdown === name}
                                        onToggle={(isOpen) => setOpenDropdown(isOpen ? name : null)}
                                    >
                                        <Dropdown.Toggle
                                            variant="light"
                                            className="text-dark w-full sm:w-auto"
                                            style={{ backgroundColor: "#F0D7E0", border: "0", borderRadius: "5px", fontSize: "15px", fontWeight: "bold" }}
                                        >
                                            {ids.length ? `${name}` : name}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {list.length === 0 ? (
                                                <Dropdown.Item disabled>No {name} available</Dropdown.Item>
                                            ) : (
                                                list.map((item) => (
                                                    <Dropdown.Item key={item._id} as="div" className="d-flex align-items-center">
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={ids.includes(item._id)}
                                                            onChange={() => toggleSelection(item._id, setState, ids)}
                                                            label={item.name}
                                                            className="text-black"
                                                            style={{ fontSize: "15px" }}
                                                        />
                                                    </Dropdown.Item>
                                                ))
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                ))}
                            </div>
                          
                        </div> */}
                         <div className=' flex  justify-end'>
                                                <button onClick={goBack} className="text-white bg-black hover:text-white outline-1 outline-double rounded-md text-sm font-semibold px-4 py-2 d-inline-block">Back</button>
                                               
                                            </div>
                    </div>
                </div>

                <div className="common-table-wrapper m-0">
                    <div className="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th className=' text-center'>Sr.No.</th>
                                    <th>Coach Name</th>
                                    <th>Create Date</th>
                                    <th>Target Date</th>
                                    <th>Email</th>
                                    <th>Region</th>
                                    <th>Country</th>
                                    <th>State</th>
                                    <th>District</th>
                                    <th>Block</th>
                                    <th>Total Session <br />For Teacher</th>
                                    <th>Total School <br />Visit</th>
                                    <th>Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr className="justify-center">
                                        <td colSpan="100%">
                                            <h6 className="text-center text-lg">Loading...</h6>
                                        </td>
                                    </tr>
                                ) : user?.length > 0 ? (
                                    user?.map((item, i) => {
                                        return (
                                            <tr key={item?._id}>
                                                <td className=' text-center'>{indexNumber + i + 1}</td>
                                                <td>{item?.coach?.full_name || "-"}</td>
                                                <td>{formatDate(item?.created_date)}</td>
                                                <td>{formatDate(item?.target_date)}</td>
                                                <td>{item?.coach?.email || "-"}</td>
                                                <td>{item?.coach?.coach_location?.region?.name || "-"}</td>
                                                <td>{item?.coach?.coach_location?.country?.name || "-"}</td>
                                                <td>{item?.coach?.coach_location?.state?.name || "-"}</td>
                                                <td>{item?.coach?.coach_location?.district?.name || "-"}</td>
                                                <td>{item?.coach?.coach_location?.block?.name || "-"}</td>
                                                <td>
                                                    {item?.targets?.length
                                                        ? item.targets.reduce((sum, t) => sum + (Number(t.target) || 0), 0)
                                                        : "-"}
                                                </td>
                                                <td>{item?.school_ids.length || "-"}</td>
                                                <td className="action-tab flex justify-center gap-2">
                                                    {/* <button
                onClick={() => handleNavigation("/coach-management/view-coach", { id: _id })}
                className="action-icon view-info bg-slate-300 rounded-full p-1"
            >
                <MdRemoveRedEye style={{ width: "17px", height: "17px" }} />
            </button> */}

                                                    {/* Edit Coach Button */}
                                                
                                                    <button
                                                        onClick={() =>
                                                            navigate("/coach-target-management/add-target", {
                                                              state: {
                                                                id: item?._id,
                                                                screen: "Edit",
                                                              },
                                                            })
                                                          }
                                                          
                                                        className="action-icon view-info bg-slate-300 rounded-full p-1"
                                                    >
                                                        <MdMode style={{ width: "17px", height: "17px" }} />
                                                    </button>

                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr className="justify-center">
                                        <td colSpan="100%">
                                            <h6 className="text-center text-lg">No Target Found</h6>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <Row className=" px-2 mb-4 py-2">
                        <Col md={12}>
                            <Pagination
                                data={user}
                                indexNumber={indexNumber}
                                totalPage={totalPages}
                                setPage={setPage}
                                page={page}
                                paginationHandler={paginationHandler}
                                total={total}
                            />
                        </Col>
                    </Row>
                </div>

                <Toastify />
            </Tab.Container>

          




        </>
    );
};

export default CoachTragetManagementView;
